import PropTypes from 'prop-types';
import cn from 'classnames';
import s from './Emdash.module.less';

export default function Emdash({ muted }) {
  // eslint-disable-next-line react/jsx-no-literals
  return <span className={cn({ [s.muted]: muted })}>—</span>;
}

Emdash.propTypes = {
  muted: PropTypes.bool,
};

Emdash.defaultProps = {
  muted: true,
};
